
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/coupons",
      function () {
        return require("private-next-pages/profile/coupons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/coupons"])
      });
    }
  